import { createSlice } from '@reduxjs/toolkit';
import apiLiveChat from '../../api/livechat';
import axios from '../../helper/axiosIntanceApiZalo';
// utils
import axiosIntanceAccessZalo from '../../helper/axiosIntanceAccessZalo';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  sidebarChat: [],
  conversationContent: [],
  infoUserSelected: false,
  endPage: false,
};
//
// name : teen store quan li
const slice = createSlice({
  name: 'conversation_live',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // ACCESS LIVE CHAT
    statusSidebarChatSuccess(state, action) {
      const participants = action.payload;
      state.sidebarChat = participants;
      state.isLoading = false;
    },
    // ACCESS LIVE CHAT
    statusGetConversationSuccess(state, action) {
      console.log('reset reset')
      const participants = action.payload;
      state.conversationContent = participants;
      state.endPage = false;
      state.isLoading = false;
    },
    // ACCESS LIVE CHAT
    statusLoadMoreMessageSuccess(state, action) {
      console.log('more more')
      const participants = action.payload;
      state.conversationContent = participants.concat(state.conversationContent)
      state.endPage = false;
      state.isLoading = false;
    },
    // ACCESS LIVE CHAT
    statusIsSelectedSuccess(state, action) {
      const participants = action.payload;
      state.infoUserSelected = participants;
      state.isLoading = false;
      state.sidebarChat = state.sidebarChat.map((item, index) => {
        if (item.from_id === participants?.user_id) {
          item.is_read = 1;
        }
        return item;
      });
    },
    statusSendMessageSuccess(state, action) {
      const participants = action.payload;
      state.isLoading = false;
    },
    statusReceiMessageWebhookSuccess(state, action) {
      const { message, from_id, is_read, to_id, from_display_name, to_display_name, time, attachment_url_image, from_avatar, type, message_short, attachments, to_avatar, channel } = action.payload;
      if (state.infoUserSelected.user_id === to_id || state.infoUserSelected.user_id === from_id) {
        state.conversationContent.push({ is_read, attachments, type, time, src: 1, message, attachment_url_image, from_id, from_display_name, to_display_name, to_id, from_avatar, to_avatar, channel });
      }
      var index_new_chat = -1;
      state.sidebarChat = state.sidebarChat.map((item, index) => {
        if ((item.to_id === to_id && item.from_id === from_id) || (item.to_id === from_id && item.from_id === to_id)) {
          item.from_id = from_id;
          item.from_display_name = from_display_name;
          item.to_display_name = to_display_name;
          item.to_avatar = to_avatar;
          item.from_avatar = from_avatar;
          item.to_id = to_id;
          item.message = message;
          item.message_short = message_short;
          item.attachments = attachments;
          item.time = time;
          item.type = type;
          item.is_read = is_read;
          item.channel = channel;
          index_new_chat = index;
        }
        return item;
      });
      if (index_new_chat > -1) {
        var temp = state.sidebarChat[index_new_chat];
        delete state.sidebarChat[index_new_chat];
        state.sidebarChat.unshift(temp);
      } else {
        var new_sidebarChat = state.sidebarChat;
        new_sidebarChat.unshift({ is_read, attachments, message_short, type, time, src: 1, message, attachment_url_image, from_id, from_display_name, to_id, from_avatar, to_avatar, to_display_name, channel });
        state.sidebarChat = new_sidebarChat;
      }
      state.isLoading = false;
    },
    statusJoinChat(state, action) {
      const participants = action.payload;
      var new_sidebarChat = state.sidebarChat;
      new_sidebarChat.unshift(participants);
      state.sidebarChat = new_sidebarChat;
    },
    statusReceiveMessageForPlugin(state, action) {
      const participants = action.payload;
      const {socket_id, message, from_id, is_read, to_id, from_display_name, to_display_name, time, attachment_url_image, from_avatar, type, message_short, attachments, to_avatar, channel } = action.payload;
      if (state.infoUserSelected.user_id === to_id || state.infoUserSelected.user_id === from_id) {
        state.conversationContent.push({ is_read, attachments, type, time, src: 1, message, attachment_url_image, from_id, from_display_name, to_display_name, to_id, from_avatar, to_avatar, channel });
      }
      var index_new_chat = -1;
      console.log(action.payload)
      state.sidebarChat = state.sidebarChat.map((item, index) => {
        // if (
        //   (item.from_id == to_id && from_id == "") || (item.from_id == from_id && to_id == "")
        //   || (item.to_id === to_id && item.from_id === from_id) || (item.to_id === from_id && item.from_id === to_id)
        //   || (item.to_id == from_id && to_id == "") || (item.to_id == to_id && from_id == "")
        // ) 
        if (
          item.from_id == socket_id || item.to_id==socket_id
        ) {
          item.from_id = from_id;
          item.from_display_name = from_display_name;
          item.to_display_name = to_display_name;
          item.to_avatar = to_avatar;
          item.from_avatar = from_avatar;
          item.to_id = to_id;
          item.message = message;
          item.message_short = message_short;
          item.attachments = attachments;
          item.time = time;
          item.type = type;
          item.is_read = is_read
          index_new_chat = index;
        }
        return item;
      });
      if (index_new_chat > -1) {
        var temp = state.sidebarChat[index_new_chat];
        delete state.sidebarChat[index_new_chat];
        state.sidebarChat.unshift(temp);
      } else {
        var new_sidebarChat = state.sidebarChat;
        new_sidebarChat.unshift({ is_read, attachments, message_short, type, time, src: 1, message, attachment_url_image, from_id, from_display_name, to_id, from_avatar, to_avatar, to_display_name, channel });
        state.sidebarChat = new_sidebarChat;
      }
      state.isLoading = false;

    },
    statusEndPageSuccess(state, action) {
      state.endPage = true;
    }
  }
});
//user_id: '9039282189603070496', message: 'test 13', contentType: 'text', attachments: Array(0)}
// Reducer
export default slice.reducer;

export function getSidebarChat(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await apiLiveChat.getListRecentChat(params);
      dispatch(slice.actions.statusSidebarChatSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getConversation(params) {
  return async (dispatch) => {

    try {
      const response = await apiLiveChat.getConversation({ user_id: params.user_id });
      if (response.data?.data) {
        dispatch(slice.actions.statusIsSelectedSuccess(params));
        dispatch(slice.actions.statusGetConversationSuccess(response.data.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getMoreMesageConversation(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      console.log('more more load load load load')
      const response = await apiLiveChat.getConversation(params);
      if (response.data?.data) {
        if (response.data.data.length === 0) {
          console.log('end page')
          dispatch(slice.actions.statusEndPageSuccess());
        } else {
          console.log('more more page')
          dispatch(slice.actions.statusLoadMoreMessageSuccess(response.data.data));
        }

      }

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function sendMessageForLive(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      console.log(params)
      const response = await apiLiveChat.sendMessage(params);
      params.message_id = response.data.data.message_id;
      if (response.data.data.attachment_url_image) {
        params.attachment_url_image = response.data.data.attachment_url_image;
      }
      if (response.data.data.message_id) {
        dispatch(slice.actions.statusSendMessageSuccess(params));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function receiMessageFromWebhookLiveChat(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {

      // if (data.message?.attachments) {
      //   data.attachment_url_image = data.message.attachments[0].payload.url;
      // }

      dispatch(slice.actions.statusReceiMessageWebhookSuccess(data));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function onEventReceiveMessage(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.statusReceiveMessageForPlugin(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function onEventJoinChat(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.statusJoinChat(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------




